
// stuff
import { User } from '../../providers/user';
import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController } from 'ionic-angular';
/**
 * Import Pages
 */
import { HomePage } from '../../pages/home/home';

/*
  Generated class for the AccountLoginForm component.

  See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
  for more info on Angular 2 Components.
*/
@Component({
  selector: 'account-login-form',
  templateUrl: 'account-login-form.html'
})
export class AccountLoginFormComponent {
  login: { email?: string, password?: string } = {};
  submitted = false;
  loader: any = false;
  signFocus: any;


  constructor(
    public user: User,
    public loading: LoadingController,
    public nav: NavController,
    public alert: AlertController
  ) {
    user.isConnected().then((user) => {
      if (user) {
        console.warn('user connected, redirecting to home..');
        this.nav.setRoot(HomePage);
      }
    });
  }

  public onLogin(form) {
    this.submitted = true;
    if (form.valid) {
      let loader = this.loading.create({
        content: 'Bitte warten..',
        duration: 10000
      });
      loader.present().then(() => {
        this.user.fb.auth().signInWithEmailAndPassword(this.login.email, this.login.password).catch((error) => {
          loader.dismiss().then(() => {
            this.errorHandler(error);
          });
        }).then(() => {
          this.nav.setRoot(HomePage);
          loader.dismiss();
        });
      });
    }
  }

  errorHandler(error) {
    let errorCode = error.code;
    let errorMessage = error.message;
    let handler = User.errorHandler(errorCode, errorMessage);
    let alert = this.alert.create({
      title: handler.title,
      subTitle: handler.message,
      buttons: ['OK']
    });
    alert.present();
  }
}


// WEBPACK FOOTER //
// ./src/components/account-login-form/account-login-form.ts